module.exports = __webpack_public_path__ + "img/logo.5341ebf4.png";